export const COMPACT_LAYOUT_MAX_WIDTH = 750;
export const TABS_CONTAINER_HEIGHT = 40;
export const TOGGLE_ISSUE_WATCHING_KEY = 'w';
